import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/shipping-calculator')({
  component: () => <Outlet />,
})
